import { HiChatBubbleLeftRight } from "react-icons/hi2";
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

const ChatWidget = () => {
  const location = useLocation();
  const isMaintenancePage = 
    location.pathname === '/jupeb-maintenance' ||
    location.pathname === '/jamb-maintenance' ||
    location.pathname === '/neco-maintenance';

  if (isMaintenancePage) {
    return null;
  }

  return (
    <div className="fixed max-w-[1440px] z-50"> 
       <div className='fixed bottom-28 right-5 flex flex-col items-center justify-center font-inter md:right-8 lg:right-16 lg:bottom-20 xl:right-24 xl:bottom-28'>
             <motion.a 
              initial={{scale: 1, backgroundColor: '#559502'}}
              whileHover={{ backgroundColor: '#080808', scale: 1.07}}
              whileTap={{ scale: 0.9 }} 
                href="mailto:morgengreen1@gmail.com" target="_blank" rel="noopener noreferrer"
                className='bg-[#559502] h-14 w-14 rounded-full border-[1.5px] border-solid shadow-2xl flex items-center justify-center cursor-pointer hover:scale-105 md:w-16 md:h-16
                            lg:w-20 lg:h-20 lg:border-2 xl:w-24 xl:h-24'>
                  
                  <div className="relative">
                      <HiChatBubbleLeftRight className='text-3xl text-[#ffffff] md:text-4xl lg:text-[40px] xl:text-5xl' />
                      <motion.span
                        className="absolute -top-1 -right-1 w-3 h-3 bg-white rounded-full shadow-lg"
                        animate={{ scale: [0.5, 1.5, 0.5], opacity: [0.5, 1.5, 0.5] }}
                        transition={{ duration: 1.5, repeat: Infinity, repeatDelay: 0.3 }}
                      />
                  </div>

             </motion.a>
              
             
             <p className='text-xs text-white font-medium pt-2 w-20 text-center leading-3.5 md:text-[12px] md:w-full md:pt-3 lg:text-[13px] xl:text-sm xl:pt-3.5'>
                Send us a message
             </p>
       </div>
    </div>
  )
}
export default ChatWidget
